exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".slider-template-news .new-slider-subtitle,.slider-template-news .new-slider-title{text-overflow:ellipsis;overflow:hidden;display:-webkit-box!important;-webkit-line-clamp:2;white-space:normal}.slider-template-news .new-slider-subtitle{-webkit-line-clamp:4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/features/PageHome/components/Noticias/NewsSlider.scss
// module id = 876
// module chunks = 0